import useSWR, {SWRResponse} from 'swr';
import {ISubCategory} from '../../types/common/SubCategory';

const URL = `${process.env.REACT_APP_BACKEND_URL}/subcategories`;

export const useSubCategories = (selectedCategory: number | null): SWRResponse<{subcategories?: ISubCategory[]}> => {
  return useSWR(() => selectedCategory ? URL + `?categoryId=${selectedCategory}` : null);
};
